import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../language/language.service';

@Component({
  selector: 'app-rodo',
  templateUrl: './rodo.component.html',
  styleUrls: ['./rodo.component.scss']
})
export class RodoComponent implements OnInit {
  constructor(public languageService: LanguageService) { }

  ngOnInit(): void {
  }
}